import React from 'react'
import SEO from 'components/presenter/seo/seo'
import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next'
import LoadingBackdrop from 'components/presenter/form/LoadingBackdrop'
import cn from 'classnames'
import * as styles from './page.module.css'

const Page = ({
  children,
  location,
  isLoading = false,
  seoMeta = {},
  className = '',
}) => {
  const { t } = useTranslation()
  const { language, languages } = useI18next()
  const { title, meta, appName, author, description, images } = seoMeta
  
  const bannerLink = () => `${location.origin}/images/share.jpg`

  return (
    <>
      <SEO 
        title={title || t('seo.title')}
        meta={meta}
        appName={appName || t('common.appName')}
        author={author || t('seo.author')}
        description={description || t('seo.description')}
        lang={language}
        langs={languages}
        images={images || (location ? [{
          url: bannerLink(),
          width: 1200,
          height: 630
        }] : null)}
        location={location}
        keywords='jetso, news, leaflet, promotion, campagin, jetso search, find jetso, good jetso, jetso recommend, explosion rate, turnover, digital marketing, marketer, employer, sale, jetso site, shop, 著數, 消息, 傳單, 推廣, 推廣活動, 著數搜索, 找著數, 好著數, 著數推介, 曝光率, 營業額, 數字營銷, 營銷員, 僱主, 銷售, 著數網, 店鋪'
      />
      <div className={cn(styles.root, className)}>
        { children }
        <LoadingBackdrop className={styles.loader} open={isLoading} />
      </div>
    </>
  )
}
export default Page